<template>
    <div id="account-name">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="fullname"
          name          ="fullname"
          type          ="text"
          class         =""
          :label        ="$t('regis-full-name')"
          placeholder   =""
          :value        ="updateDetails.customerName"
          @input        = "setInputValue($event.target)"
          autocomplete  ="off"
          outline
          floating-label
          required
          clear-button
        >
        </f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {

    },
    mounted (){

    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('customer', [
          'updateDetails'
      ])
    },
    methods: {
      ...mapActions('customer', [
          'setUpdateCustomerName',
          'validateInput',
      ]),

      setInputValue(inputEl){
        this.$emit("setInputValue", inputEl);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }

    }
  }
</script>